<template>
  <div class="location_page">
    <a-row>
      <a-col :span="15">
        <div class="location_data">
          <div class="link-div">
            <a-button type="link" @click="goBack"> <a-icon type="left" />返回</a-button>
            <div class="flex">
              <div>
                {{ time }}更新<a-button type="link" @click="update"><a-icon type="sync"/></a-button>
              </div>
              <div class="link_layout" v-show="showType === 1">
                <span class="link_selected">按公司主体查看 </span>
                <a-button type="link" class="link_btn" @click="changeShowType"> 按省份查看 </a-button>
              </div>
              <div class="link_layout" v-show="showType === 2">
                <a-button type="link" class="link_btn" @click="changeShowType"> 按公司主体查看 </a-button>
                <span class="link_selected">按省份查看 </span>
              </div>
            </div>
          </div>
          <div class="location_content">
            <div v-if="showType === 1">
              <a-table
                :columns="typeColumns"
                :dataSource="locationListByType"
                :pagination="false"
                size="small"
                :rowClassName="rowColor"
                :rowKey="(record, index) => index"
                :key="(record, index) => index"
              >
              </a-table>
            </div>
            <div v-if="showType === 2">
              <a-table
                :columns="provinceColumns"
                :dataSource="locationListByProvince"
                :pagination="false"
                size="small"
                :rowClassName="rowColorByProvince"
                :rowKey="(record, index) => index"
                :key="(record, index) => index"
              >
              </a-table>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { locationListQuery, refreshLocationList } from '@/api/project';
import Event from '@/utils/event';
import moment from 'moment';

const typeMap = { 1: '总公司', 2: '子公司', 3: '分公司' };
const typeColumns = [
  {
    title: '公司类型',
    dataIndex: 'type',
    align: 'center',
    width: '100px',
    customRender: type => {
      return typeMap[type];
    }
  },
  { title: '公司主体', dataIndex: 'name', width: '300px' },
  {
    title: '设立时间',
    dataIndex: 'establishDate',
    align: 'center',
    width: '150px',
    customRender: date => {
      if (date.length !== 0) {
        var newDate = date.slice(0, 4) + '年' + date.slice(4, 6) + '月' + date.slice(6) + '日';
      }
      return newDate;
    }
  },
  { title: '省份', dataIndex: 'province', align: 'center' },
  { title: '城市', dataIndex: 'city', align: 'center' },
  { title: '区/县', dataIndex: 'districe', align: 'center', width: '80px' },
  { title: '注册地址', dataIndex: 'addressDetail', align: 'center' }
];
const provinceColumns = [
  { title: '省份', dataIndex: 'province', align: 'center' },
  { title: '城市', dataIndex: 'city', align: 'center' },
  { title: '区/县', dataIndex: 'districe', align: 'center', width: '100px' },
  { title: '公司主体', dataIndex: 'name', width: '300px' },
  {
    title: '公司类型',
    dataIndex: 'type',
    align: 'center',
    width: '80px',
    customRender: type => {
      return type === 1 ? '总公司' : type === 2 ? '子公司' : type === 3 ? '分公司' : ' ';
    }
  },
  {
    title: '设立时间',
    dataIndex: 'establishDate',
    align: 'center',
    width: '150px',
    customRender: date => {
      if (date.length !== 0) {
        let newDate = date.slice(0, 4) + '年' + date.slice(4, 6) + '月' + date.slice(6) + '日';
        return newDate;
      } else {
        return date;
      }
    }
  }
];
export default {
  name: 'businessLocation',
  props: ['companyId'],
  data() {
    return {
      locationListByType: [],
      locationListByProvince: [],
      typeColumns: typeColumns,
      showType: 1,
      provinceColumns: provinceColumns,
      tableTypeColor: 'rowcolor1',
      tableProvinceColor: 'rowcolor1',
      time: ''
    };
  },
  created() {
    this.locationListQuery();
  },
  methods: {
    async locationListQuery() {
      try {
        this.locationListByType = [];
        this.locationListByProvince = [];
        const res = await locationListQuery({ companyId: this.companyId });
        if (res.code === 200) {
          this.getListByType(res.data);
          this.getListByProvince(res.data);
          if (res.data.length > 0) {
            let time = res.data[0].createAt || '';
            this.time = moment(time).format('YYYY-MM-DD');
          }
        } else {
        }
      } catch (err) {
        console.log(err);
      }
    },
    getListByType(locationList) {
      this.locationListByType = locationList.slice(0);
      this.locationListByType.sort((a, b) => {
        return a.type - b.type;
      });
      this.locationListByType.forEach((e, index, arr) => {
        if (index > 0 && e.type !== arr[index - 1].type) {
          if (this.tableTypeColor === 'rowcolor1') {
            this.tableTypeColor = 'rowcolor2';
          } else {
            this.tableTypeColor = 'rowcolor1';
          }
        }
        e['typerowcolor'] = this.tableTypeColor;
      });
    },
    getListByProvince(locationList) {
      this.locationListByProvince = locationList.slice(0);
      let provinceList = [
        '北京市',
        '上海市',
        '广东省',
        '天津市',
        '重庆市',
        '河北省',
        '山西省',
        '内蒙古自治区',
        '辽宁省',
        '吉林省',
        '黑龙江省',
        '江苏省',
        '浙江省',
        '安徽省',
        '福建省',
        '江西省',
        '山东省',
        '河南省',
        '湖北省',
        '湖南省',
        '广西壮族自治区',
        '广西省',
        '海南省',
        '四川省',
        '贵州省',
        '云南省',
        '西藏',
        '西藏自治区',
        '陕西省',
        '甘肃省',
        '青海省',
        '宁夏省',
        '宁夏回族自治区',
        '新疆维吾尔自治区',
        '台湾',
        '香港',
        '澳门',
        ''
      ];
      this.locationListByProvince.sort((a, b) => {
        return provinceList.indexOf(a.province) - provinceList.indexOf(b.province);
      });
      this.locationListByProvince.forEach((e, index, arr) => {
        if (index > 0 && e.province !== arr[index - 1].province) {
          if (this.tableProvinceColor === 'rowcolor1') {
            this.tableProvinceColor = 'rowcolor2';
          } else {
            this.tableProvinceColor = 'rowcolor1';
          }
        }
        e['prorowcolor'] = this.tableProvinceColor;
      });
    },
    changeShowType() {
      if (this.showType === 1) {
        this.showType = 2;
      } else {
        this.showType = 1;
      }
    },
    goBack() {
      Event.$emit('toInfoDetail', 0);
    },
    rowColor(record, index) {
      return [record.typerowcolor, 'table-row'];
    },
    rowColorByProvince(record, index) {
      return [record.prorowcolor, 'table-row'];
    },
    async update() {
      try {
        let res = await refreshLocationList({ companyId: this.companyId });
        if (res.code === 200) {
          this.locationListQuery();
        }
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="less">
.location_page {
  .location_data {
    border: 1px solid #f0f2f5;
    border-radius: 5px;
    padding: 15px;
    margin-bottom: 40px;
    .link-div {
      display: flex;
      justify-content: space-between;
    }
    .link_layout {
      // float: right;
      .link_selected {
        margin-right: 10px;
        text-decoration: underline;
      }
      .link_btn {
        padding: 0;
        margin-right: 10px;
      }
    }
    .location_content {
      padding: 30px 0px 50px 0px;
    }
  }
  .ant-table-small {
    border: none;
  }
  .table-row {
    font-size: 14px;
    border: none;
  }
  .ant-table-tbody > tr > td {
    border: none;
  }
  .ant-table-thead > tr > th:nth-child(2) {
    text-align: center;
  }
  .ant-table-thead > tr > th:nth-child(4) {
    text-align: center;
  }
  .rowcolor1 {
    background-color: #fff;
  }
  .rowcolor2 {
    background-color: #f5f5f5;
  }
  .flex {
    display: flex;
    align-items: center;
  }
}
</style>
